import React from 'react';
import { withRouter } from 'react-router-dom';
import {MobileInfoItem} from "../../../../components/utils/MobileInfoItem";
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import { parseNumToFixed } from '../../../../utils/common';

const Item = ({ item, isSemiManufacture, viewMode, isMobile }) => {
    const rawData = item.rawmaterial;

    const getPlanBalance = () => {
        return (item.prevInventory || 0) + (item.coming || 0) - (item.expenditure || 0) - (item.writeoff || 0);
    }

    const planBalance = parseNumToFixed(getPlanBalance(), 3);
    const difference = parseNumToFixed(parseFloat(item.quantity - planBalance), 3);

    if (isMobile && !isSemiManufacture && item.rawMaterial && viewMode === 'view') {
        return (
            <tr key={item.id} className="kt-datatable__row">
                <td colSpan="100%" className="kt-datatable__cell">
                    <div style={{ padding: '0.5rem 1rem' }}>
                        <div style={{
                            fontSize: '0.9rem',
                            marginBottom: '0.75rem',
                            fontWeight: 600,
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {rawData.name || 'Не указано'}, {MEASURES_RAW[rawData.measure]}
                        </div>

                        <div style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            gap: '0.75rem',
                            overflowX: 'auto',
                            paddingBottom: '0.5rem',
                            marginRight: '-1rem',
                            alignItems: 'flex-start'
                        }}>
                            <MobileInfoItem
                                label="Ост. (план)"
                                value={planBalance || 0}
                            />
                            <MobileInfoItem
                                label="Ост. (факт)"
                                value={parseNumToFixed(item.quantity, 3)}
                            />
                            <MobileInfoItem
                                label="Разница"
                                value={difference}
                                danger={planBalance > item.quantity}
                            />
                            <MobileInfoItem
                                label="Сумма"
                                value={`${item.sum ? parseNumToFixed(item.sum) : parseNumToFixed(parseFloat(rawData.last_price * difference))} ₽`}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    if (isMobile && viewMode === 'input') {
        return (
            <tr key={item.id} className="kt-datatable__row">
                <td colSpan="100%" className="kt-datatable__cell">
                    <div style={{ padding: '0.5rem 1rem' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            marginBottom: '0.5rem',
                        }}>
                            <div style={{
                                fontWeight: 600,
                                fontSize: '0.9rem',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                flex: 1,
                                minWidth: 0
                            }}>
                                {rawData.name || 'Не указано'}, {MEASURES_RAW[rawData.measure]}
                            </div>

                            <div style={{ flexShrink: 0 }}>
                                <MobileInfoItem
                                    label="Введено"
                                    value={parseNumToFixed(item.quantity, 3) || 0}
                                    style={{ minWidth: '50px',
                                        flexShrink: 0 }}
                                />
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    return (
        <tr key={item.id} className="kt-datatable__row">
            <td width="200px" className="kt-datatable__cell">
                <span>{rawData.name || 'Не указано'}</span>
            </td>
            <td align="left" width="auto" className="kt-datatable__cell">
                <span>{MEASURES_RAW[rawData.measure]}</span>
            </td>
            {viewMode === 'view' && (
                <td align="center" width="200px" className="kt-datatable__cell">
                    <span>{planBalance}</span>
                </td>
            )}
            <td align="center" width="200px" className="kt-datatable__cell">
                <span
                    style={{width: '150px', margin: '0 auto'}}>{parseNumToFixed(item.quantity, 3) || 0}
                </span>
            </td>
            {viewMode === 'view' && (
                <>
                    <td style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                        <span style={{ color: planBalance > item.quantity ? 'red' : 'green' }}>
                            {difference}
                        </span>
                    </td>
                    <td style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                        <span>{item.sum ? parseNumToFixed(item.sum) : parseNumToFixed(parseFloat(rawData.last_price * difference)) || 0} ₽</span>
                    </td>
                </>
            )}
        </tr>
    );
};

export const ItemRow = withRouter(Item);
